import { AppsOutlined, NumbersOutlined } from "@mui/icons-material";
import { Box, Tab, Tabs as TabPanel } from "@mui/material";
import { Children, useEffect, useMemo, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { SwitchTransition } from "react-transition-group";
import PropTypes from 'prop-types';
import styles from "./Tabs.module.css";

const calcDirection = (oldVal, newVal) => {
  if (oldVal - newVal < 0) return "left";
  if (oldVal - newVal > 0) return "right";
  return "";
};

const Tabs = ({ setActiveTab, children, className }) => { 
  const [active, setActive] = useState({ index: 0, direction: "left", ref: null });
  
  useEffect(() => setActiveTab && setActiveTab({index: active.index, name: children[active.index].key}), [active]);

  const items = useMemo( () => {
    return Children.toArray(children)
  }, [children]);

  const changeTab = (event, value) => {
    setActive((oldValue) => {
      return { ...oldValue, index: value, direction: calcDirection(oldValue.index, value) };
    });
  };

  return (
    <div className="tabs">
      <Box sx={{width: '100%'}}>
        <TabPanel
          className={className ?? null}
          value={active.index} onChange={changeTab} centered sx={{mb: 1, borderBottom: 1, borderColor: 'divider'}}>
          {
            items.map((item) => <Tab key={item.props.title} label={item.props.title} icon={item.props.icon ?? null} iconPosition={item.props.iconPosition ?? 'start'}/>)
          }
        </TabPanel>
      </Box>  
      <SwitchTransition>
        <CSSTransition
          key={active.index}
          nodeRef={items[active.index].ref}
          timeout={300}
          classNames={`slide${active.direction}`}
        >
          <div className="tab-content">{items[active.index]}</div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

Tabs.propTypes = {
  children: PropTypes.node.isRequired
};

export default Tabs;